import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { BaseQuestionProps } from "../..";
import { FormControl } from "@/components/ui/form";

export const Boolean: React.FC<BaseQuestionProps> = ({ field, disabled, className }) => {
  return (
    <RadioGroup
      disabled={disabled}
      onValueChange={(value) => {
        field.onChange(value);
      }}
      {...field}
      className={`flex flex-row space-x-14 sm:space-x-4 md:space-x-6`}
    >
      <div className="flex flex-row items-center space-x-3">
        <FormControl>
          <RadioGroupItem value="true" disabled={disabled} className={className} />
        </FormControl>
        <div className={`font-xs pb-2 font-light text-black ${disabled ? "opacity-50" : ""}`}>Yes</div>
      </div>
      <div className="flex flex-row items-center space-x-3">
        <FormControl>
          <RadioGroupItem value="false" disabled={disabled} className={className} />
        </FormControl>
        <div className={`font-xs pb-2 font-light text-black ${disabled ? "opacity-50" : ""}`}>No</div>
      </div>
    </RadioGroup>
  );
};
